export enum BALANCE_PAGE_TAB {
    INVOICE = 'invoice',
    CARD = 'card',
}
